import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button, Container } from 'reactstrap'
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { connect } from "react-redux";
import ReactQuill from 'react-quill';

import { faEye, faDownload,faPaperclip, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTable from 'react-table';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import AddHistoryService from '../../../../../../Service/OPSServices/SWInternalServices/AddHistoryService';
import CustomModal from '../../../../../Components/Modals/CustomModal';
import { Editor,SetInnerHtmlWithClassReplacement } from '../../../../../../Utils/Constants';
import MyTasksCompleted from '../../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksCompleted.svg';
import MyTasksInProgress from '../../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksInProgress.svg';
import MyTasksNew from '../../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksNew.svg';
import MyTasksOverdue from '../../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksOverdue.svg';
import GetTaskHistoryService from '../../../../../../Service/OPSServices/SWInternalServices/GetTaskHistoryService';
import SignOffIcon from '../../../../../../../src/designUtils/OpsDashboard/MyTasks/SignOffIcon.svg';
import fetchAllTasksUserTasksService from '../../../../../../Service/OPSServices/SWInternalServices/fetchAllTasksUserTasksService';
import TasksEndDatePicker from '../../../../../Components/Input/TasksEndDatePicker';


function ViewTaskHistory(props) {
  const [referenceText, setReferenceText] = useState(props.viewTaskData.reference || '');
  const [verifiedByUser,setVerifiedByUser]=useState('')
  const [text, setText] = useState('')
  const [selectedFiles, setSelectedFiles] = useState([])
  const [historyList, setHistoryList] = useState([]);
  const [taskStatus, setTaskStatus] = useState("");
  const [member, setMember] = useState("");
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(false);
  const [isGridCommentsOpen, setIsGridCommentsOpen] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [saveLoading, setSaveLoading] = useState(false)
  const [completing, setCompleting] = useState(false)
  const [commentsText, setCommentsText] = useState()
  const [popupHistory, setPopupHistory] = useState('')
  const [taskPriority,setTaskPriority]=useState(props.viewTaskData.priority?props.viewTaskData.priority:'')
  const [loadScreen, setLoadScreen] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const [taskExpanded, setTaskExpanded] = useState(false)
  const [taskTitlePopup,setTaskTitlePopup]= useState('')
  const [taskReference,setReference]= useState('')
  const [taskReferenceExpandPopup,setTaskReferenceExpandPopup]= useState('') 
  const [taskReopenComment,setTaskReopenComment]=useState(false)
  const [verifiedByLoading, setVerifiedByLoading] = useState(false)
  const [endPannedDate,setEndPannedDate]=useState()
  const [dateChange,setDateChange]=useState(false)
  useEffect(() => {
    setLoadScreen(true)
    const data = {
      taskId: props.viewTaskData.SWTeamTaskId
    }
    GetTaskHistoryService(props.token, data).then((responce) => {
      if (responce) {
        console.log('responce')
        console.log(responce)
        setHistoryList(responce.historyList)
        // setTaskPriority(responce.historyList[0].priority)
        // console.log(responce.historyList[0].priority);
        
        setLoadScreen(false)
      }
    })

  }, [])

  const handleChangeStatus = (e) => {
    setTaskStatus(e.target.value)
  }
  const handleAssignedToChange = (e) => {
    setMember(e.target.value)
  }
  const handleReferenceText=(e)=>{
    setVerifiedByUser(e.target.value)
  }

  // Filter agency members based on task's store (IntegerId)
  const getFilteredAgencyMembers = () => {
    if (!props.agencyMemberList || !Array.isArray(props.agencyMemberList)) {
      return [];
    }
    
    // If task has no store (IntegerId is null, 0, or undefined), show all agency members
    if (!props.viewTaskData.IntegerId || props.viewTaskData.IntegerId === 0) {
      return props.agencyMemberList;
    }
    
    // Filter agency members who are mapped to the task's store
    return props.agencyMemberList.filter((member) => {
      // Check if member has storeMappings array and it includes the task's IntegerId
      if (member.storeMappings && Array.isArray(member.storeMappings)) {
        return member.storeMappings.includes(props.viewTaskData.IntegerId);
      }
      // If storeMappings is not available, include the member (fallback)
      return true;
    });
  };
  const handleQuillChange = (value) => {
    setText(value);
  };
  const handleRemoveFile = (file) => {
    const updatedFiles = selectedFiles.filter((f) => f !== file);
    setSelectedFiles(updatedFiles);
  };
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };
  const previousDate = props.viewTaskData && props.viewTaskData.plannedEndDate? props.viewTaskData.plannedEndDate.slice(0, 10): '';
	const newDate = endPannedDate ? endPannedDate.slice(0, 10) : '';
  const handleSubmitHistory = (flag,isReopen) => {

    const formData = new FormData();

    formData.append("referenceText", referenceText?referenceText:props.viewTaskData.reference);
    formData.append("verifiedByUser", verifiedByUser?verifiedByUser:props.viewTaskData.verifiedBy);
    formData.append("taskId", props.viewTaskData.SWTeamTaskId);
    formData.append("status", taskStatus);
    formData.append('intId',props.store.integerID?props.store.integerID:0,)
    formData.append('endPannedDate',endPannedDate?endPannedDate:props.viewTaskData.plannedEndDate)
    // formData.append('endPannedDate',endPannedDate)
    formData.append("taskPriority", taskPriority?taskPriority:props.viewTaskData.priority);
    if(flag !==3){
    formData.append("note", text);
    }
    formData.append("flag", 0);
    if (flag == 1) {
      formData.append("action", 1);
      setCompleting(true)
    }
    if (flag == 2) {
     
      formData.append("action", 2);
      setSaveLoading(true)
    }
    if (flag == 4) {
      formData.append("action", 4);
      setVerifiedByLoading(true)
      setCompleting(true)
    }
    if (flag == 5) {
      formData.append("action", 5);
      setSaveLoading(true)
    }
    if (flag === 3) {
      formData.append("action", 3);
  
      if (isReopen) {
        formData.append("note", 'Task has been Re-opened by ' + props.userData.firstName + ' ' + props.userData.lastName +" ; Comment : "+ ' ' + text);
      } else {
        formData.append("note", 'Task has been Accepted by ' + props.userData.firstName + ' ' + props.userData.lastName);
      }
  
      setSaveLoading(true);
    }
    formData.append("assignedTo", member ? member : props.viewTaskData.assignedTo ? props.viewTaskData.assignedTo : '');
    if (selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("taskAttachmentFile", selectedFiles[i]);
      }
    }
    else {
      formData.append("taskAttachmentFile", []);
    }
    AddHistoryService(props.token, formData).then((res) => {
      if (res) {
        console.log('res AddHistoryService')
        console.log(res)
        setSelectedFiles([])
        setTaskStatus('')
        setText('')
        setMember('')
        if(props.action== true){
          let data = {
            intId: props.store && props.store.integerID
              ? props.store.integerID
              : 0
          }
          props.handleCloseCreateTaskPopup(res.tasklist)
          console.log('props.handleCloseCreateTaskPopup(res.tasklist)');
          fetchAllTasksUserTasksService(props.token,data).then((res)=>{
            if(res){
              console.log(res);
              props.setAllUsersTasks(res.tasklist)
              props.setViewTaskPopup(false)
            }
          })
        
         
        }
        else{
          console.log('window.location.reload();');
          props.handleCloseCreateTaskPopup(res.tasklist)
        }
      }
      setCompleting(false)
      setSaveLoading(false)
      setVerifiedByLoading(false)
    })

  }
  const getAsinList = (asinsList) => {
    if (!asinsList) return [];

    try {
        // New format: JSON string
        const parsed = JSON.parse(asinsList);

        if (Array.isArray(parsed)) {
            return parsed.filter(Boolean);
        }
    } catch (error) {
        // Existing format: comma-separated string
    }

    return asinsList
        .split(',')
        .map(asin => asin.trim())
        .filter(Boolean);
};
  const fileExtensions = ['csv', 'docx', 'xlsx', 'xls'];
  const handleEndPlannedDateChange=(e)=>{
    if (props.viewTaskData.plannedEndDate !== e)
    {
      setDateChange(true)
    }

    setEndPannedDate(e)
    console.log(e);
  }
  const viewDownloadFile = async (file) => {
    console.log(file)
    try {
      // Extract file name without extension
      let fileName = file.taskAttachmentFile.split('/').pop(); // Get the last part of the path
      fileName = fileName.split('.')[0]; // Remove the file extension
  
      // Fetch the file from the URL
      const fileUrl = file.taskAttachmentFile;
      // const response = await fetch(fileUrl);
      const response = await fetch(fileUrl, {
        method: 'GET',
        //mode: 'no-cors', 
        referrerPolicy: 'no-referrer', // Set referrerPolicy here
        cache: 'no-store',
             });
      
  
      if (!response.ok) {
        throw new Error(`Network response was not ok for file ID: ${file.SWTeamTaskAttachmentId}`);
      }
  
      // Create a blob from the response
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
  
      // Create a temporary download link
      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = fileName || 'downloaded_file'; // Use extracted file name or fallback
      document.body.appendChild(downloadLink);
  
      // Trigger the download
      downloadLink.click();
  
      // Cleanup
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(blobUrl);
  
      console.log(`File downloaded successfully: ${fileName}`);
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  };



  const historyNote = SetInnerHtmlWithClassReplacement(props.viewTaskData.taskTitle)
  const historyReference = SetInnerHtmlWithClassReplacement(props.viewTaskData.reference)
  const TaskReadMore = ({ htmlContent, maxLength, history }) => {

    const toggleReadMore = () => {
      setTaskTitlePopup(history)
      setTaskExpanded(!taskExpanded);
    };
    const truncatedContent = htmlContent.length > maxLength ? htmlContent.substring(0, maxLength) + '...' : htmlContent;
    return (
      <div>
        <div className="issue-description-set d-flex flex-wrap" dangerouslySetInnerHTML={{ __html: truncatedContent }} />
        {htmlContent.length > maxLength && (
          <span style={{ fontSize: '13px' }} onClick={toggleReadMore} className="cursor-pointer d-flex justify-content-end">
            ....Read More
          </span>
        )}
      </div>
    )
  };
  const ReadMore = ({ htmlContent, maxLength, history }) => {

    const toggleReadMore = () => {
      setPopupHistory(history)
      setIsExpanded(!isExpanded);
    };
    const truncatedContent = htmlContent.length > maxLength ? htmlContent.substring(0, maxLength) + '...' : htmlContent;
    return (
      <div>
        <div className="issue-description-set d-flex flex-wrap" dangerouslySetInnerHTML={{ __html: truncatedContent }} />
        {htmlContent.length > maxLength && (
          <span style={{ fontSize: '13px' }} onClick={toggleReadMore} className="cursor-pointer d-flex justify-content-end">
            ....Read More
          </span>
        )}
      </div>
    )
  };
  const RefrenceReadMore = ({ htmlContent, maxLength, history }) => {

    const toggleReadMore = () => {
      setReference(history)
      setTaskReferenceExpandPopup(!taskExpanded);
    };
    const truncatedContent = htmlContent.length > maxLength ? htmlContent.substring(0, maxLength) + '...' : htmlContent;
    return (
      <div>
        <div className="issue-description-set d-flex flex-wrap" dangerouslySetInnerHTML={{ __html: truncatedContent }} />
        {htmlContent.length > maxLength && (
          <span style={{ fontSize: '13px' }} onClick={toggleReadMore} className="cursor-pointer d-flex justify-content-end">
            ....Read More
          </span>
        )}
      </div>
    )
  };
  const show = (path) => {
    // Extract file extension from the file path
    console.log(path)
    const separatedPath = path.split("/");
    const fileName = separatedPath.pop(); // Get the file name with extension
    const fileExtension = fileName.split(".").pop(); // Get the extension

    // Check for file extensions that should be closed quickly after showing the modal
    const quickCloseExtensions = ["xlsx", "csv", "xls", "docx"];

    // If the file is of a type that requires quick close (like .xlsx, .csv, etc.)
    if (quickCloseExtensions.includes(fileExtension)) {
      setFilePath(path);        // Set the file path for displaying in the iframe
      setIsAttachmentOpen(true); // Open the modal

      // Close the modal after 200 milliseconds
      setTimeout(() => {
        setIsAttachmentOpen(false);
      }, 200);
    } else {
      // For all other file types (e.g., PDFs, images), just show the modal without auto-closing
      setFilePath(path);        // Set the file path for the iframe
      setIsAttachmentOpen(true); // Open the modal
    }
  };
  const replaceCommentsText = SetInnerHtmlWithClassReplacement(commentsText);
 
const handlePriorityChange=(e)=>{
  setTaskPriority(e.target.value)
  console.log(e.target.value);
}

  return (
    <Row>
      <Col md={6}>
        <Card className='card-of-problemarea  p-3'>
          <Row>
            <Col md={6}>
              <Label><b>Task Title : </b>
              <TaskReadMore htmlContent={historyNote} maxLength={90} history={props.viewTaskData.taskTitle } />
        </Label>
            </Col>
            <Col md={6}>
            <Label className=' d-flex justify-content-end ' >
            <span  style={{backgroundColor:props.viewTaskData.rowColor}} className='viewtaskstatus'>
              {props.viewTaskData.status ==="New"?
              <img src={MyTasksNew} alt='not found' />:
              props.viewTaskData.status ==="In Progress"?
              <img src={MyTasksInProgress} alt='not found' />:
              props.viewTaskData.status ==="Completed"?
              <img src={MyTasksCompleted} alt='not found' />:
              props.viewTaskData.status ==="Signed Off"?
              <img className='mr-1' src={SignOffIcon} alt='not found' />:
              props.viewTaskData.status ==="Overdue"?
              <img src={MyTasksOverdue} alt='not found' />:'' }

              <b>{props.viewTaskData.status}</b>
              </span>
              </Label>
              
            </Col>

            <Col md={6} className='mt-1 mb-1'>
            <Label><b>Planned Start Date : </b></Label>
            <Input 
                      type='text'
                      // checked={accept}
                      // className='mt-2'
                      value={props.viewTaskData.plannedStartDate}
                      disabled
                      />
            </Col>
           
            {/* <Col md={6} className='mt-1 mb-1'> */}
            {props.viewTaskData.status !== "Signed Off" ? (
                <TasksEndDatePicker
                  viewTaskData={props.viewTaskData}
                  onPlannedEndDateChange={handleEndPlannedDateChange}
                />
              ) : (
                <Col md={6} className='mt-1 mb-1'>
                  <Label><b>Planned End Date:</b></Label>
                  <Input 
                      type='text'
                      // checked={accept}
                      // className='mt-2'
                      value={props.viewTaskData.plannedEndDate}
                      disabled
                      />
                </Col>
              )}
          
           
            <Col md={6} className='' >
            <Label className=""><b>Priority : </b> </Label>
             {props.viewTaskData.status!=="Signed Off"?
                <select className='form-control w-100'
                   id="priority"
                  name="priority"
                  value={taskPriority?taskPriority:props.viewTaskData.priority}
                  onChange={handlePriorityChange}>
                  <option id='' disabled selected value=''>--Select Priority--</option>
                  <option value="Critical">Critical</option>
                  <option value="Urgent">Urgent</option>
                  <option value="High">High</option>
                  <option value="Normal">Normal</option>
                  <option value="Low">Low</option>
                 
                </select>:
                <p className='mb-0'> {taskPriority}</p>}
                {props.viewTaskData.status ==="Signed Off"?
                <Label className='mt-2'><b>Completion Date : </b>{props.viewTaskData.completedAt}</Label>:''}
            </Col>
            <Col md={6}>
              <Label> <b>Reference :</b>  </Label>
               {props.viewTaskData.status!=="Signed Off"?   <Input
                  type="textarea"
                  name="address"
                  className="w-100"
                  placeholder='Enter Text'
                  value={referenceText}
                  onChange={(e) => setReferenceText(e.target.value)}
              />:
              // props.viewTaskData.reference
              <RefrenceReadMore htmlContent={historyReference} maxLength={90} history={props.viewTaskData.reference } />
              }

            </Col>
            {/* <Col md={6}>
            <Label className="d-flex mt-2"><b>Assigned To : </b>
              <p className="ml-5 mb-0">
                    {props.viewTaskData.assignedTo == props.loggedUserId && props.viewTaskData.status =="New" ?
                      <>
                      <Input 
                      type='checkbox'
                      // checked={accept}
                      // className='mt-2'
                      onChange={()=>handleSubmitHistory(3)}
                      />
                      Accept </>:''
                    }
                 
                </p></Label>
                {props.viewTaskData.status!=="Signed Off"?
                <>
              {props.accessLevel ===0?
                  <select
                  id='assigned To'
                  // value={props.viewTaskData.accountType === "Agency" ? props.viewTaskData.assignedTo : ""}
                  // disabled={props.viewTaskData.accountType === "Agency"}
                  onChange={(e) => handleAssignedToChange(e)}
                  className='form-control w-100 mt-2'>
                    
                    {props.viewTaskData.accountType !== "Agency" && props.viewTaskData.accountType !== "Partners"? (
                      <>
                        <option disabled value="">-- Assigned To --</option>
                        {props.teamMemberList &&
                          props.teamMemberList.map((member) => (
                            <option
                              key={member.employeeId}
                              title={member.email}
                              value={member.employeeId}
                              selected={member.employeeId == props.viewTaskData.assignedTo}

                            >
                              {member.employeeName}
                            </option>
                          ))}
                      </>
                    ) : (
                      <option value="">{props.viewTaskData.assignedName}</option>
                    )}
                </select> :
                 <select
                 id='assigned To'
                 onChange={(e) => handleAssignedToChange(e)
                 }
                 className='form-control w-100 mt-2'>
                 <option id='' disabled selected value=''>--Assigned To--</option>
                 {getFilteredAgencyMembers() && getFilteredAgencyMembers().map((member) => (
                   <option
                   title={member.email}
                     value={member.id}
                     selected={member.id == props.viewTaskData.assignedTo}
                   >{member.name}</option>

                 ))}
               </select> 
                }
               </> :props.viewTaskData.assignedName
            }
          
            </Col> */}
           <Col md={6}>
  <Label className="d-flex mt-2">
    <b>Assigned To : </b>
    <p className="ml-5 mb-0">
      {props.viewTaskData.assignedTo === props.loggedUserId && props.viewTaskData.status === "New" ? (
        <>
          <Input
            type="checkbox"
            onChange={() => handleSubmitHistory(3)}
          />
          Accept
        </>
      ) : null}
    </p>
  </Label>
  {props.viewTaskData.status !== "Signed Off" ? (
    <>
      {/* Case 1: accessLevel === 0 (Super Admin) */}
      {props.accessLevel === 0 ? (
        (props.viewTaskData.accountType === "Agency" || props.viewTaskData.accountType === "Partners") ? (
          <div className="mt-2">{props.viewTaskData.assignedName}</div>
        ) : (
          <select
            className="form-control w-100 mt-2"
            id="assignedTo"
            name="assignedTo"
            value={member||props.viewTaskData.assignedTo || ""}
            onChange={handleAssignedToChange}
          >
            <option disabled value="">
              -- Assigned To --
            </option>
            {props.teamMemberList &&
              props.teamMemberList.map((member) => (
                <option
                  key={member.employeeId}
                  value={member.employeeId}
                  title={member.email}
                >
                  {member.employeeName}
                </option>
              ))}
          </select>
        )
      ) : 
      /* Case 2: LoggedUserRole === 3 (Agency Admin) */
      props.LoggedUserRole === 3 ? (
        // Show name only for Agency roles, allow reassignment for others
        (props.viewTaskData.role === "Agency User" || 
         props.viewTaskData.role === "Agency Store POC" || 
         props.viewTaskData.role === "Agency Client" ||
         props.viewTaskData.role === "Agency Admin") ? (
          <div className="mt-2">{props.viewTaskData.assignedName}</div>
        ) : (
          <select
            className="form-control w-100 mt-2"
            id="assignedTo"
            name="assignedTo"
            value={member||props.viewTaskData.assignedTo || ""}
            onChange={handleAssignedToChange}
          >
            <option disabled value="">
              -- Assigned To --
            </option>
            {getFilteredAgencyMembers() &&
              getFilteredAgencyMembers().map((member) => (
                <option
                  key={member.id}
                  value={member.id}
                  title={member.email}
                >
                  {member.name}
                </option>
              ))}
          </select>
        )
      ) : 
      /* Case 3: LoggedUserRole === 2 (Store Manager) */
      props.LoggedUserRole === 2 ? (
        props.viewTaskData.role === "Store Manager" ? (
          <div className="mt-2">{props.viewTaskData.assignedName}</div>
        ) : (
          <select
            className="form-control w-100 mt-2"
            id="assignedTo"
            name="assignedTo"
            value={member||props.viewTaskData.assignedTo || ""}
            onChange={handleAssignedToChange}
          >
            <option disabled value="">
              -- Assigned To --
            </option>
            {getFilteredAgencyMembers() &&
              getFilteredAgencyMembers().map((member) => (
                <option
                  key={member.id}
                  value={member.id}
                  title={member.email}
                >
                  {member.name}
                </option>
              ))}
          </select>
        )
      ) : (
        <select
          className="form-control w-100 mt-2"
          id="assignedTo"
          name="assignedTo"
          value={member||props.viewTaskData.assignedTo || ""}
          onChange={handleAssignedToChange}
        >
          <option disabled value="">
            -- Assigned To --
          </option>
          {getFilteredAgencyMembers() &&
            getFilteredAgencyMembers().map((member) => (
              <option
                key={member.id}
                value={member.id}
                selected={member.id == props.viewTaskData.assignedTo}
                title={member.email}
              >
                {member.name}
              </option>
            ))}
        </select>
      )
      }
    </>
  ) : (
    <div className="mt-2">{props.viewTaskData.assignedName}</div>
  )}
</Col>


            <Col md={6}>
          
            <Label className="d-flex mt-2"><b>Sign Off : </b></Label>
            {props.viewTaskData.status !== "Signed Off" ? (
    <>
      {/* Case 1: accessLevel === 0 (Super Admin) */}
      {props.accessLevel === 0 ? (
        (props.viewTaskData.accountType === "Agency" || props.viewTaskData.accountType === "Partners") ? (
          <div className="mt-2">{props.viewTaskData.verifiedName}</div>
        ) : (
          <select
            className="form-control w-100 mt-2"
            id="verifiedByUser"
            name="verifiedByUser"
            value={verifiedByUser ||props.viewTaskData.verifiedBy || ""}
            onChange={handleReferenceText}
          >
            <option disabled value="">
              -- Select User --
            </option>
            {props.teamMemberList &&
              props.teamMemberList.map((member) => (
                <option
                  key={member.employeeId}
                  value={member.employeeId}
                  title={member.email}
                >
                  {member.employeeName}
                </option>
              ))}
          </select>
        )
      ) : 
      /* Case 2: LoggedUserRole === 3 (Agency Admin) */
      props.LoggedUserRole === 3 ? (
        // Show name only for Agency roles, allow reassignment for others
        (props.viewTaskData.role === "Agency User" || 
         props.viewTaskData.role === "Agency Store POC" || 
         props.viewTaskData.role === "Agency Client" ||
         props.viewTaskData.role === "Agency Admin") ? (
          <div className="mt-2">{props.viewTaskData.verifiedName}</div>
        ) : (
          <select
            className="form-control w-100 mt-2"
            id="verifiedByUser"
            name="verifiedByUser"
            value={verifiedByUser ||props.viewTaskData.verifiedBy || ""}
            onChange={handleReferenceText}
          >
            <option disabled value="">
              -- Select User --
            </option>
            {getFilteredAgencyMembers() &&
              getFilteredAgencyMembers().map((member) => (
                <option
                  key={member.id}
                  value={member.id}
                  title={member.email}
                >
                  {member.name}
                </option>
              ))}
          </select>
        )
      ) : 
      /* Case 3: LoggedUserRole === 2 (Store Manager) */
      props.LoggedUserRole === 2 ? (
        props.viewTaskData.role === "Store Manager" ? (
          <div className="mt-2">{props.viewTaskData.verifiedName}</div>
        ) : (
          <select
            className="form-control w-100 mt-2"
            id="verifiedByUser"
            name="verifiedByUser"
            value={verifiedByUser ||props.viewTaskData.verifiedBy || ""}
            onChange={handleReferenceText}
          >
            <option disabled value="">
              -- Select User --
            </option>
            {getFilteredAgencyMembers() &&
              getFilteredAgencyMembers().map((member) => (
                <option
                  key={member.id}
                  value={member.id}
                  title={member.email}
                >
                  {member.name}
                </option>
              ))}
          </select>
        )
      ) : (
        <select
          className="form-control w-100 mt-2"
          id="verifiedByUser"
          name="verifiedByUser"
          value={verifiedByUser ||props.viewTaskData.verifiedBy || ""}
          onChange={handleReferenceText}
        >
          <option disabled value="">
            -- Select User --
          </option>
          {getFilteredAgencyMembers() &&
            getFilteredAgencyMembers().map((member) => (
              <option
                key={member.id}
                value={member.id}
                selected={member.id == props.viewTaskData.verifiedBy}
                title={member.email}
              >
                {member.name}
              </option>
            ))}
        </select>
      )
      }
    </>
  ) : (
    <div className="mt-2">{props.viewTaskData.verifiedName}</div>
  )}
            </Col>
          
          
            {props.viewTaskData.status!=="Signed Off"?
            <><Col className='mt-2' md={6}>

            <p for="Attachment">
              <b>Upload Helpful Files : </b>
            </p>
            <label
              htmlFor="fileInput"
              className="custom-file-input-label text-center"
            >
              <i className="fas fa-upload"></i>
              <br /> Choose File

              <input
                type="file"
                id="fileInput"
                name="ticketAttachment"
                className="custom-file-input"
                onChange={handleFileChange}
                multiple
              />
            </label>
            <span style={{ fontSize: "14px" }}> <br /><br /> <b>Attached File List :</b></span>
            <ul style={{ color: "green", fontSize: "13px", maxHeight: '75px', 
                                        overflowY: 'auto' }}>
              {selectedFiles
                ? selectedFiles.map((file, index) => (
                  <li key={index}>
                    <div className='d-flex'>
                    <p title={file.name}className='mb-0 mt-2 comment-paragraph-taskfiles'>{file.name}</p>
                    <button
                      className="btn"
                      onClick={() => handleRemoveFile(file)}
                    >
                      <FontAwesomeIcon
                        color="red"
                        size="15px"
                        icon={faWindowClose}
                      />
                    </button>
                    </div>
                  </li>
                ))
                : ""}
            </ul>
          </Col>
          <Col md={6}>
          <p className='mb-1 mt-2' style={{ fontSize: "14px" }}><b className='mb-1' >Store and Asins List :</b></p>
        
                                <p mb-0 title={props.viewTaskData.storeName} className='m-0 comment-paragraph-task-storename'><b>{props.viewTaskData.storeName}</b></p>
                                <div
                                        style={{
                                          maxHeight: '75px',
                                          overflowY: 'auto',
                                        }}
                                      >
                                        {getAsinList(props.viewTaskData.asinsList).map((asin, index) => (
                                        <p key={index} title={asin} className="mb-1">
                                            {asin}
                                        </p>
                                    ))}
                                      </div>


          </Col>

          <Col md={12} className='mt-2'>
            {/* <div className='mendetory-star'>
          <span style={{ color: 'red' }}>
            <b> * </b>
          </span>
        </div> */}
            <Label><b>Comments : <span style={{ color: 'red' }}> *</span></b></Label>
            {/* <div className='star-quell'> */}
            <ReactQuill
              className=""
              theme={'snow'}
              modules={Editor.modules}
              formats={Editor.formats}
              value={text}
              onChange={handleQuillChange}
              bounds={'.quill-prod'}
              placeholder='Note' />
            {/* </div> */}
          </Col>
          <Col md={12} className='mt-2 d-flex justify-content-center'>
          <Button className='btn-background-color '
              disabled={!(text) || (saveLoading || completing||verifiedByLoading)}
              onClick={() => {
                if (props.viewTaskData.status === "Completed" && props.viewTaskData.verifiedBy == props.loggedUserId) {
                  // setTaskReopenComment(true);
                  handleSubmitHistory(3, true);
                }
                else if(props.viewTaskData.status === "Overdue" && new Date(endPannedDate) > new Date()) {
                  handleSubmitHistory(5, true);
                }
                else {
                  handleSubmitHistory(2,false);
                }
              }}
              >
                {saveLoading ? 'Saving..' : 'Add'}
              </Button>
                    {props.viewTaskData.verifiedBy == props.loggedUserId && props.viewTaskData.status==="Completed"?( 
                     <Button
                      className='btn-background-color ml-3'
                      disabled={!text || completing || saveLoading||verifiedByLoading}
                      onClick={() => handleSubmitHistory(4)}
                    >
                      {verifiedByLoading ? 'Saving..' : 'Sign Off'}
                    </Button>
                      ): <Button
                      className='btn-background-color ml-3'
                      disabled={!text || completing || saveLoading||verifiedByLoading}
                      onClick={() => {
                        if (props.viewTaskData.assignedTo === props.loggedUserId && props.viewTaskData.verifiedBy == props.loggedUserId) {
                          // setTaskReopenComment(true);
                          handleSubmitHistory(4, false);
                        } else {
                          handleSubmitHistory(1,false);
                        }
                      }}
                    >
                      {completing ? 'Saving..' : 'Complete'}
                    </Button>}
          </Col></>:  <Col md={6}>
          <p className='mb-1 mt-2' style={{ fontSize: "14px" }}><b className='mb-1' >Store and Asins List :</b></p>
        
                                <p mb-0 title={props.viewTaskData.storeName} className='m-0 comment-paragraph-task-storename'><b>{props.viewTaskData.storeName}</b></p>
                                <div
                                        style={{
                                          maxHeight: '75px',
                                          overflowY: 'auto',
                                        }}
                                      >
                                        {props.viewTaskData.asinsList &&
                                          props.viewTaskData.asinsList
                                            .split(',')
                                            .map((asin, index) => (
                                              <p key={index} title={asin} className="mb-1">
                                                {asin}
                                              </p>
                                            ))}
                                      </div>


          </Col>

            }
            
          </Row>
        </Card>
      </Col>

      <Col md={6}>
        <LoadingOverlay
          active={loadScreen}
          styles={{

            overlay: (base) => ({
              ...base,
              background: '#f1f4f6',
              opacity: 1,
              marginTop: '15px'
            }),
            content: (base) => ({
              ...base,
              color: '#000',
            }),
          }}
          spinner={<Loader active type="ball-pulse" />}
          text="Loading task history Comments..."
        >
           <Card className='card-of-problemarea p-2 mb-1 scrollable-div p-0 overflow-auto 'style={{ maxHeight: '736px' }}>
          {historyList && historyList.map((history) => {

            const historyNote = SetInnerHtmlWithClassReplacement(history.note)
            return (
                <Col md={12} >
                  <Row className='  d-flex justify-content-between'>
                    <Col md={6} className='task-short-name ml-2'><h6><b>{history.createdByName.split(' ').map(word => word[0]).join('').toUpperCase()}</b></h6></Col>
                    <Col md={6}><p className='created-at mt-1'>{history.createdAt}</p></Col>
                    <Col md={12} className='mt-2'>
                      <ReadMore htmlContent={historyNote} maxLength={200} history={history.note} />
                    </Col>
                    {
                      history.files && history.files.length >0?
                      <Col md={12}>
                        {
                          history.files.map((file)=>(
                            <span>
                            
                              {file.taskAttachmentFile.match(/(jpeg|jpg|png|gif)$/i)?
                              <img width={'20%'} onClick={()=>show(file.taskAttachmentFile)} src={file.taskAttachmentFile} className="cursor-pointer"/>:
                              <FontAwesomeIcon
                                className="mr-2 ml-3"
                                icon={faPaperclip}
                                onClick={() => show(file.taskAttachmentFile)}
                              />
                            }
                            </span>
                          ))
                        }
                    
                      </Col>:''
                    }
                  
                  </Row>
                  <p className='linetaskhistory'/>
                </Col>
               
            )
          })}
            </Card>

        </LoadingOverlay>
      </Col>


      <CustomModal
        header={<> Attachment
          <FontAwesomeIcon className="ml-3" style={{ cursor: 'pointer' }} icon={faDownload} onClick={() => viewDownloadFile({ 'taskAttachmentFile': filePath, 'SWTeamTaskAttachmentId': 0 })} />
        </>}
        isOpen={isAttachmentOpen}
        toggle={() => setIsAttachmentOpen(!isAttachmentOpen)}
        size={'lg'}
        className='my-task-custom-module'
      >
      <Card  className='card-of-problemarea p-2 '>
          <div>
            <iframe
              src={

                filePath
              }
              title="File Display"
              width="100%"
              height="500"
            ></iframe>
          </div>
      </Card>
      </CustomModal>
      <CustomModal
        header={"Task Title"}
        isOpen={taskExpanded}
        toggle={() => setTaskExpanded(!taskExpanded)}
        size={"lg"}
        className="curve-popup"
        footer={
          <>
            <Button
              color={"link"}
              onClick={() =>
                setTaskExpanded(!taskExpanded)
              }
            >
              Cancel
            </Button>
          </>
        }
      >
        <p className="task-title-set" style={{ fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: taskTitlePopup }} />
        {/* <Label>{ticketHistoryText}</Label> */}
      </CustomModal>
      <CustomModal
        header={'Comments'}
        isOpen={isGridCommentsOpen}
        toggle={() => setIsGridCommentsOpen(!isGridCommentsOpen)}
        className='my-task-custom-module'
        size={'md'}
      >
        <Card className='card-of-problemarea'>
          <Col md={12} className='p-3'>
            <Label>
              <p className="issue-discription-set" dangerouslySetInnerHTML={{ __html: replaceCommentsText }} />
            </Label>
          </Col>
        </Card>

      </CustomModal>
      <CustomModal
        header={"Task comment"}
        isOpen={isExpanded}
        toggle={() => setIsExpanded(!isExpanded)}
        size={"lg"}
        className="curve-popup"
        footer={
          <>
            <Button
              color={"link"}
              onClick={() =>
                setIsExpanded(!isExpanded)
              }
            >
              Cancel
            </Button>
          </>
        }
      >
        <p className="issue-discription-set" style={{ fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: popupHistory }} />
        {/* <Label>{ticketHistoryText}</Label> */}
      </CustomModal>
       <CustomModal
        header={"Reference"}
        isOpen={taskReferenceExpandPopup}
        toggle={() => setTaskReferenceExpandPopup(!taskReferenceExpandPopup)}
        size={"lg"}
        className="curve-popup"
        footer={
          <>
            <Button
              color={"link"}
              onClick={() =>
                setTaskReferenceExpandPopup(!taskReferenceExpandPopup)
              }
            >
              Cancel
            </Button>
          </>
        }
      >
        <p className="issue-discription-set" style={{ fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: taskReference }} />
        {/* <Label>{ticketHistoryText}</Label> */}
      </CustomModal>
    </Row>
  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,

  };
};

export default connect(mapStateToProps)(ViewTaskHistory)